import ScoringScoreBadge, { AIIcon } from '@modules/scoring/components/ScoringScoreBadge';
import { JobApplicationRaw } from '@modules/jobApplications/types';
import { useScoreJobApplication } from '@modules/jobApplications/hooks/useScoreJobApplication';
import { Button } from '@mui/material';

interface ScoringCellProps {
    row: JobApplicationRaw;
    onOpenScoring: () => void;
}

const ScoringCell = ({ row, onOpenScoring }: ScoringCellProps) => {
    const jobAppId = String(row._id);
    const { handleScore, isScoring } = useScoreJobApplication(jobAppId, row.scoringStatus);

    if (isScoring) {
        return <Button
            size="small"
            color="success"
            disabled={!row.jobOffer?._id || !row.talent?.resume?.path}
            onClick={handleScore}
            startIcon={<AIIcon size={14} />}
        >
            En cours...
        </Button>
    }

    if (row.resumeScore != null) {
        return (
            <ScoringScoreBadge
                score={row.resumeScore}
                status="done"
                scoreExplainer={row.resumeExplainer ?? undefined}
                onViewMoreClick={onOpenScoring}
            />
        );
    }

    if (row.scoringStatus === 'error') {
        return (
            <Button
                size="small"
                startIcon={<AIIcon size={14} />}
                onClick={handleScore}
            >
                Réessayer
            </Button>
        );
    }

    return (
        <Button
            size="small"
            disabled={!row.jobOffer?._id || !row.talent?.resume?.path}
            onClick={handleScore}
            startIcon={<AIIcon size={14} />}
        >
            Scorer
        </Button>
    );
};

export default ScoringCell;
